import { call, put, select, takeLatest } from 'redux-saga/effects';
import Cookies from "cookies-js";
import * as types from '../constants/actionTypes';
import * as pharmacy from '../api/pharmacyApi';
import { linkPharmacyAccount } from '../api/healthSourceApi';
import { userRefresh } from "../api/ssoApi";
import { getCityOrZip } from "../api/typeaheadApi";
import * as d from "../reducers/domainReducer";
import { logAPI } from "../api/andyliticsApi";
import { getDomain } from "../helpers/Tools";

export default function* pharmacySaga() {
    yield takeLatest([types.ARCHIVE_UNARCHIVE_RX_START], handlePharmacyAction);
    yield takeLatest([types.GET_PHARMACY_BY_STORENUMBER_START], handlePharmacyAction);
    yield takeLatest([types.LINK_PHARMACY], handlePharmacyAction);
    yield takeLatest([types.LOAD_ARCHIVED_RX_LIST_START], handlePharmacyAction);
    yield takeLatest([types.LOAD_ORDERREFILLS_LIST_START], handlePharmacyAction);
    yield takeLatest([types.LOAD_PHARMACYDASHBOARD_START], handlePharmacyAction);
    yield takeLatest(types.CLOSEST_PHARMACY, handlePharmacyAction);
    yield takeLatest([types.LOAD_PICKUP_HOURS_START], handlePharmacyAction);
    yield takeLatest([types.LOAD_RX_LIST_START], handlePharmacyAction);
    yield takeLatest([types.PHARMACY_LIST_START], handlePharmacyAction);
    yield takeLatest([types.RECENTPHARMACY_LIST_START], handlePharmacyAction);
    yield takeLatest([types.RX_DETAIL], handlePharmacyAction);
    yield takeLatest([types.RX_READY_FOR_PICKUP], handlePharmacyAction);
    yield takeLatest([types.SET_FAVOURITE_PHARMACY_START], handlePharmacyAction);
    yield takeLatest([types.SUBMIT_IVR_ORDER_REQUEST], handlePharmacyAction);
    yield takeLatest([types.INTERNAL_RX_TRANSFER_START], handlePharmacyAction);
    yield takeLatest([types.EXTERNAL_RX_TRANSFER_START], handlePharmacyAction);
    yield takeLatest([types.UNLINK_RX_TRANSFER_START], handlePharmacyAction);
    yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handlePharmacyAction);
    yield takeLatest(types.CITY_ZIP_LIST, handlePharmacyAction);
    yield takeLatest(types.ARCHIVE_UNLINKED_RX_TRANSFER_START, handlePharmacyAction);
    //yield takeLatest([types.SWITCH_USER_SAGA], handleUserSwitch); //<--- putting it off as it's causing for the dashboard not to load
}

function* handlePharmacyAction(data) {
    const start = new Date();
    const stateData = yield select((state) => state.common);

    if (stateData && !stateData.rxDown) {
        try {
            const domainData = yield select((state) => state.domain);
            const membershipData = yield select((state) => state.memberships);

            //const userDetails = yield select((state) => state.sso.userDetails);  // <-- this makes assumptions about state a saga can't make (because it's not tied into the state lifecycle)
            const userDetails = data.userDetails || data.userData || (data.payload ? data.payload.userDetails || data.payload.userData : null);

            let authToken = domainData.t;
            let refreshToken = domainData.rt;

            //retrive pharmacy proxy id from domain data 
            const currentPharmacyUser = d.hydratePharmacyUser(domainData.cpu);
            let pharmacyProxyId = currentPharmacyUser && currentPharmacyUser.pharmacyPatientId ? currentPharmacyUser.pharmacyPatientId : "";

            const locations = yield select((state) => state.locations);

            //if (userDetails && userDetails.access_token) {
            let defaultPharmacy;
            let citiesList;
            let thisType = "";
            try {
                thisType = data.type;
            }
            catch (err) {
                //console.log(err);
            }
            switch (thisType) {
                case types.LOAD_PHARMACYDASHBOARD_START:
                case types.USER_AUTHENTICATE_SUCCESS:
                    try {
                        if (domainData.lt === null || domainData.lt === 0) {
                            yield put({ type: types.GEOLOCATION });
                        } else if (!(locations && locations.city && locations.state)) {
                            yield put({ type: types.GEOADDRESS, location: { lat: domainData.lt, lng: domainData.ln } });
                        }
                    } catch (locationerr) {
                        //console.log(locationerr);
                    }
                    if (!membershipData.isActiveFeature_Pharmacy && !pharmacyProxyId) {
                        break;
                    }
                    try {
                        const pharmacyDashBoardData = yield call(pharmacy.getPharmacyDashBoardData, pharmacyProxyId, authToken);
                        logAPI("MBHWeb.Saga.Rx.Dashboard.Get", start, null);
                        try {
                            defaultPharmacy = yield call(pharmacy.getDefaultPharmacyData, null, pharmacyProxyId, authToken);
                            logAPI("MBHWeb.Saga.Rx.DefaultPharmacy.Get", start, null);
                        }
                        catch (defaultPharmacyError) {
                            logAPI("MBHWeb.Saga.Rx.DefaultPharmacy.Get.Failure", start, null, defaultPharmacyError);
                            yield put({ type: types.RX_DEFAULT_PHARMACY_FAILURE, defaultPharmacyError: defaultPharmacyError });
                        }
                        yield put({ type: types.LOAD_PHARMACYDASHBOARD_SUCCESS, pharmacyDashboardData: pharmacyDashBoardData, defaultPharmacyData: defaultPharmacy });
                        if (typeof data.loadPickups === "undefined" || data.loadPickups) {
                            try {
                                yield call(onReadyForPickup, pharmacyProxyId, authToken);
                            }
                            catch (readyForPickupError) {
                                logAPI("MBHWeb.Saga.Rx.ReadyForPickup.Get.Failure", start, null, readyForPickupError);
                                yield put({ type: types.RX_READY_FOR_PICKUP_FAILURE, error: readyForRefillError });
                            }
                        }
                        if (typeof data.loadRefills === "undefined" || data.loadRefills) {
                            try {
                                const readyForRefill = yield call(pharmacy.getReadyForRefill, pharmacyProxyId, authToken);
                                yield put({ type: types.RX_READY_FOR_REFILL_SUCCESS, readyForRefill: readyForRefill });
                                logAPI("MBHWeb.Saga.Rx.ReadyForRefill.Get", start, null);
                            }
                            catch (readyForRefillError) {
                                logAPI("MBHWeb.Saga.Rx.ReadyForRefill.Get.Failure", start, null, readyForRefillError);
                                yield put({ type: types.RX_READY_FOR_REFILL_FAILURE, error: readyForRefillError });
                            }
                        }
                    }
                    catch (pharmacyDashboardError) {
                        yield put({ type: types.LOAD_PHARMACYDASHBOARD_FAILURE, error: pharmacyDashboardError });
                        logAPI("MBHWeb.Saga.Rx.Dashboard.Get.Failure", start, null, pharmacyDashboardError);
                    }
                    break;
                case types.CLOSEST_PHARMACY:
                    try {
                        let closestPharmacy = null;
                        const response = yield call(pharmacy.getClosestPharmacy, data.latitude, data.longitude, authToken);
                        if (response && response.length > 0) {
                            closestPharmacy = response[0];
                        }
                        yield put({ type: types.CLOSEST_PHARMACY_SUCCESS, closestPharmacy: closestPharmacy });
                        logAPI("MBHWeb.Saga.Rx.GetClosest.Get", start, null);
                    }
                    catch (closestPharmacyError) {
                        yield put({ type: types.CLOSEST_PHARMACY_FAILURE, error: closestPharmacyError });
                        logAPI("MBHWeb.Saga.Rx.GetClosest.Get.Failure", start, null, closestPharmacyError);
                    }
                    break;
                case types.LINK_PHARMACY:
                    const accountToLink = yield select((state) => state.pharmacy.accountToLink);
                    try {
                        const linkedAccount = yield call(linkPharmacyAccount, authToken, accountToLink);
                        const token = yield call(userRefresh, { refresh_token: refreshToken });
                        if (token && token.access_token) {
                            authToken = token.access_token;
                            yield put({ type: types.LINK_PHARMACY_SUCCESS, linkedAccount: linkedAccount, refreshTokenIsGood: true });
                            yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: linkedAccount.Profile})
                            yield put({ type: types.USER_AUTHENTICATE_SUCCESS, userData: token, responseError: null, isWaiting: false });
                            logAPI("MBHWeb.Saga.Rx.LinkAccount.Get", start, null, { response: linkedAccount ? linkedAccount : null });
                        }
                        else {
                            yield put({ type: types.LINK_PHARMACY_SUCCESS, linkedAccount: linkedAccount, refreshTokenIsGood: false });
                            logAPI("MBHWeb.Saga.Rx.LinkAccount.Get.Failure", start, null, { error: 'Unable to link because refresh token is no more usable.' });
                        }

                        if (data.callback) {
                            data.callback(linkedAccount);
                        }
                    }
                    catch (linkError) {
                        if (linkError && linkError.status && linkError.status === 409) {
                            const token2 = yield call(userRefresh, { refresh_token: refreshToken });
                            if (token2 && token2.access_token) {
                                authToken = token2.access_token;
                                yield put({ type: types.LINK_PHARMACY_FAILURE, error: linkError, refreshTokenIsGood: true });
                                yield put({ type: types.USER_AUTHENTICATE_SUCCESS, userData: token2, responseError: null, isWaiting: false });
                            }
                            else {
                                yield put({ type: types.LINK_PHARMACY_FAILURE, error: linkError, refreshTokenIsGood: false });
                            }
                        }
                        else {
                            yield put({ type: types.LINK_PHARMACY_FAILURE, error: linkError });
                        }
                        let linkErrorDetails = null;
                        try {
                            if (linkError) {
                                linkErrorDetails = yield call(parseRspMsg, linkError);
                            }
                        } catch (err) { };
                        logAPI("MBHWeb.Saga.Rx.LinkAccount.Get.Failure", start, null, {
                            response: {
                                requestData: accountToLink ? accountToLink : null,
                                statusCode: linkError && linkError.status ? linkError.status : null,
                                statusText: linkError && linkError.statusText ? linkError.statusText : null,
                                rspMsg: linkErrorDetails
                            }});
                    }
                    break;
                case types.EXTERNAL_RX_TRANSFER_START:
                    try {
                        var requestData = data ? data.request : '';
                        const externalRxTransferResponse = yield call(pharmacy.submitExternalRxTransfer, requestData, authToken, pharmacyProxyId);
                        if (externalRxTransferResponse) {
                            yield put({ type: types.EXTERNAL_RX_TRANSFER_SUCCESS, serviceResponse: externalRxTransferResponse });
                            logAPI("MBHWeb.Saga.Rx.RxTransfer.Get", start, null);
                        }
                        if (data.callback) {
                            data.callback(externalRxTransferResponse, null);
                        }
                    }
                    catch (submitError) {
                        if (submitError && submitError.status && submitError.status === 400) {
                            const errorMessage = yield call(getErrorMessage, submitError);
                            yield put({ type: types.EXTERNAL_RX_TRANSFER_FAILURE, error: submitError, apiErrorMessage: errorMessage });
                        }
                        else {
                            yield put({ type: types.EXTERNAL_RX_TRANSFER_FAILURE, error: submitError, serviceWaiaitng: false });
                        }
                        if (data.callback) {
                            data.callback(null, submitError);
                        }
                        logAPI("MBHWeb.Saga.PharmacyRx.Transfer.Get.Failure", start, null, submitError);
                    }
                    break;
                case types.PHARMACY_LIST_START:
                    try {
                        const pharmacyListDetails = yield call(pharmacy.getPharmacyList, data.payload, pharmacyProxyId, authToken);
                        //try {
                        //    citiesList = yield call(pharmacy.getCities, authToken);
                        //}
                        //catch (citiesPharmacyError) {
                        //    if (citiesPharmacyError && citiesPharmacyError.status && citiesPharmacyError.status !== 401) {
                        //        yield put({ type: types.CITIES_LIST_FAILURE, citiesPharmacyError: citiesPharmacyError });
                        //    }
                        //}
                        yield put({ type: types.PHARMACY_LIST_COMPLETED, pharmacyList: pharmacyListDetails, /*pharmacyCitiesList: citiesList,*/ isWaiting: false });
                        logAPI("MBHWeb.Saga.Rx.List.Get", start, null);
                    }
                    catch (pharmacyListError) {
                        logAPI("MBHWeb.Saga.Rx.List.Get.Failure", start, null, pharmacyListError);
                    }
                    break;
                case types.RECENTPHARMACY_LIST_START:
                    const recentPharmaciesList = yield call(pharmacy.getRecentlyUsedPharmacies, authToken, pharmacyProxyId);
                    try {
                        citiesList = yield call(pharmacy.getCities, authToken);
                        logAPI("MBHWeb.Saga.Rx.ListRecent.Get", start, null);
                    }
                    catch (recentPharmacyError) {
                        yield put({ type: types.RECENTPHARMACY_LIST_FAILURE, recentPharmacyError: recentPharmacyError });
                        logAPI("MBHWeb.Saga.Rx.ListRecent.Get.Failure", start, null, recentPharmacyError);
                    }
                    yield put({ type: types.RECENTPHARMACY_LIST_COMPLETED, recentPharmaciesList: recentPharmaciesList, pharmacyCitiesList: citiesList, isWaiting: false });
                    break;
                case types.CITY_ZIP_LIST:
                    try {
                        const cityZipList = yield call(getCityOrZip, data.searchModel);
                        yield put({ type: types.CITY_ZIP_LIST_SUCCESS, cityZipList: cityZipList.results });
                        logAPI("MBHWeb.Saga.Rx.CityZip.Get", start, null);
                    }
                    catch (cityZipListError) {
                        yield put({ type: types.CITY_ZIP_LIST_FAILURE, cityZipListError });
                        logAPI("MBHWeb.Saga.Rx.CityZip.Get.Failure", start, null, cityZipListError);
                    }
                    break;
                case types.LOAD_RX_LIST_START:
                    try {
                        const activeRxList = yield call(pharmacy.getActivePrescriptionList, pharmacyProxyId, authToken);
                        yield put({ type: types.LOAD_RX_LIST_COMPLETED, activeRxList: activeRxList });
                        logAPI("MBHWeb.Saga.Rx.ActivePrescriptionList.Get", start, null, activeRxList);
                    }
                    catch (rxListError) {
                        yield put({ type: types.RX_List_FAILURE, error: rxListError });
                        logAPI("MBHWeb.Saga.Rx.ActivePrescriptionList.Get.Failure", start, null, rxListError);
                    }
                    break;
                case types.LOAD_ARCHIVED_RX_LIST_START:
                    try {
                        const archivedRxList = yield call(pharmacy.getArchivedPrescriptionList, pharmacyProxyId, authToken);
                        yield put({ type: types.LOAD_ARCHIVED_RX_LIST_COMPLETED, archivedRxList: archivedRxList });
                        logAPI("MBHWeb.Saga.Rx.ArchivedPrescriptionList.Get", start, null);
                    }
                    catch (archivedRxListError) {
                        yield put({ type: types.RX_ARCHIVED_List_FAILURE, error: archivedRxListError });
                        logAPI("MBHWeb.Saga.Rx.ArchivedPrescriptionList.Get.Failure", start, null, archivedRxListError);
                    }
                    break;
                case types.ARCHIVE_UNARCHIVE_RX_START:
                    try {
                        const activeRxResponse = yield call(pharmacy.archivePrescription, data.payload.rxNumber ? data.payload.rxNumber : '', data.payload.storeNumber ? data.payload.storeNumber : '', data.payload.archive, pharmacyProxyId, authToken);
                        yield put({ type: types.ARCHIVE_UNARCHIVE_RX_SUCCESS, serviceResponse: activeRxResponse, isWaiting: false });
                        logAPI("MBHWeb.Saga.Rx.ArchivePrescription.Get", start, null);
                    }
                    catch (archiveUnarchiveError) {
                        yield put({ type: types.ARCHIVE_UNARCHIVE_RX_FAILURE, archiveUnarchiveError: archiveUnarchiveError });
                        logAPI("MBHWeb.Saga.Rx.ArchivePrescription.Get.Failure", start, null, archiveUnarchiveError);
                    }
                    break;
                case types.RX_DETAIL:
                    try {
                        const rxDetail = yield call(pharmacy.getRxDetail, authToken, data.rxNumber, data.storeNumber, data.isExternalRx ? data.isExternalRx : false, pharmacyProxyId);
                        yield put({ type: types.RX_DETAIL_SUCCESS, rxDetail: rxDetail, rxNumber: data.rxNumber, storeNumber: data.storeNumber });
                        try {
                            const rxHistory = yield call(pharmacy.getRxHistory, authToken, data.rxNumber, data.storeNumber, pharmacyProxyId);
                            yield put({ type: types.RX_HISTORY_SUCCESS, rxHistory: rxHistory });
                            logAPI("MBHWeb.Saga.Rx.RxDetail.Get", start, null);
                        }
                        catch (rxHistoryError) {
                            yield put({ type: types.RX_HISTORY_FAILURE, error: rxHistoryError });
                            logAPI("MBHWeb.Saga.Rx.RxDetail.Get.Failure", start, null, rxHistoryError);
                        }

                    }
                    catch (rxDetailError) {
                        yield put({ type: types.RX_DETAIL_FAILURE, error: rxDetailError });
                        logAPI("MBHWeb.Saga.Rx.RxDetail.Get.Failure", start, null, rxDetailError);
                    }
                    break;
                case types.RX_READY_FOR_PICKUP:
                    try {
                        yield call(onReadyForPickup, pharmacyProxyId, authToken, data.storeNumber);
                        logAPI("MBHWeb.Saga.Rx.ReadyForPickup.Get", start, null);
                    }
                    catch (readyForPickupError) {
                        logAPI("MBHWeb.Saga.Rx.ReadyForPickup.Get.Failure", start, null, readyForPickupError);
                    }
                    break;
                case types.UNLINK_RX_TRANSFER_START:
                    try {
                        const unlinkedTranfer = yield call(pharmacy.unlinkedRxTransfers, pharmacyProxyId, authToken);
                        if (unlinkedTranfer && unlinkedTranfer.status && unlinkedTranfer.status === 204) {
                            let unlinkedTranferRspMsg = null;
                            try {
                                unlinkedTranferRspMsg = yield call(parseRspMsg, unlinkedTranfer);
                            } catch (err) { }; //Keep the default unLinked transfer tile. when doesn't have body content and its fall into catch block.
                            yield put({ type: types.UNLINK_RX_TRANSFER_SUCCESS, serviceResponse: unlinkedTranferRspMsg ? unlinkedTranferRspMsg : null }); 
                            logAPI("MBHWeb.Saga.Rx.UnlinkedRxTransfer.Get", start, null, { response: { statusCode: unlinkedTranfer.status, statusText: unlinkedTranfer.statusText, rspMsg: unlinkedTranferRspMsg } });
                        } else {
                            yield put({ type: types.UNLINK_RX_TRANSFER_SUCCESS, serviceResponse: unlinkedTranfer });
                            logAPI("MBHWeb.Saga.Rx.UnlinkedRxTransfer.Get", start, null, { response: unlinkedTranfer });
                        }
                    }
                    catch (unlinkedTransferError) {
                        //if (unlinkedTransferError && unlinkedTransferError.status && unlinkedTransferError.status !== 401) {
                        yield put({ type: types.UNLINK_RX_TRANSFER_FAILURE, unlinkedTransferError: unlinkedTransferError });
                        //}
                        //else { // added this to handle SyntaxError from API                       
                        //    yield put({ type: types.AJAX_CALL_ERROR, pharmacyError: unlinkedTransferError, waitingOnUnLinkedRxTransfer: false });
                        //}
                        logAPI("MBHWeb.Saga.Rx.UnlinkedRxTransfer.Get.Failure", start, null, unlinkedTransferError);
                    }
                    break;
                case types.LOAD_ORDERREFILLS_LIST_START:
                    try {
                        const orderRefills = yield call(pharmacy.getOrderRefills, data.payload.storeNumber ? data.payload.storeNumber : '', pharmacyProxyId, authToken);
                        yield put({ type: types.LOAD_ORDERREFILLS_LIST_COMPLETED, serviceResponse: orderRefills, isWaiting: false });
                        if (data.callback) {
                            data.callback(orderRefills);
                        }
                        logAPI("MBHWeb.Saga.Rx.OrderRefills.Get", start, null);
                    }
                    catch (orderRefillsListError) {
                        yield put({ type: types.LOAD_ORDERREFILLS_LIST_FAILURE, error: orderRefillsListError });
                        logAPI("MBHWeb.Saga.Rx.OrderRefills.Get.Failure", start, null, orderRefillsListError);
                        if (data.callback) {
                            data.callback({ error: orderRefillsListError });
                        }
                    }
                    break;
                case types.LOAD_PICKUP_HOURS_START:
                    try {
                        const pickupHours = yield call(pharmacy.getPickupHours, data.payload.storeNumber ? data.payload.storeNumber : '', authToken);
                        var pickupDates = pickupHours.map((e, index) => {
                            return { value: index, label: e.LongDisplayDate };
                        });
                        yield put({ type: types.LOAD_PICKUP_HOURS_COMPLETED, serviceResponse: pickupHours, pickupDates: pickupDates, isWaiting: false });
                        logAPI("MBHWeb.Saga.Rx.PickupHours.Get", start, null);
                        if (data.callback) {
                            data.callback(pickupHours, null);
                        }
                    }
                    catch (pickupHoursError) {
                        yield put({ type: types.LOAD_PICKUP_HOURS_FAILURE, pickupHoursError });
                        logAPI("MBHWeb.Saga.Rx.PickupHours.Get.Failure", start, null, pickupHoursError);
                        if (data.callback) {
                            data.callback(null, pickupHoursError);
                        }
                    }
                    break;
                case types.SUBMIT_IVR_ORDER_REQUEST:
                    try {
                        var orderRefill = data ? data.payload.RxOrderRefillData : '';
                        const subimittedResponse = yield call(pharmacy.submitIVROrder, orderRefill, pharmacyProxyId, authToken);
                        if (subimittedResponse) {
                            yield put({ type: types.SUBMIT_IVR_ORDER_COMPLETED, serviceResponse: subimittedResponse, isWaiting: false });
                            logAPI("MBHWeb.Saga.Rx.SubmitIVROrder.Get", start, null);
                        }
                        if (data.callback) {
                            data.callback(subimittedResponse, null);
                        }
                    }
                    catch (submitIvrOrderError) {
                        yield put({ type: types.SUBMIT_IVR_ORDER_FAILURE, isWaiting: false });
                        logAPI("MBHWeb.Saga.Rx.SubmitIVROrder.Get.Failure", start, null, submitIvrOrderError);
                        if (data.callback) {
                            data.callback(null, submitIvrOrderError);
                        }
                    }
                    break;
                case types.GET_PHARMACY_BY_STORENUMBER_START:
                    try {
                        const selectedPharmacyDetails = yield call(pharmacy.getDefaultPharmacyData, data.payload.storeNumber ? data.payload.storeNumber : '', pharmacyProxyId, authToken);
                        yield put({ type: types.GET_PHARMACY_BY_STORENUMBER_COMPLETED, pharmacyByStoreNumber: selectedPharmacyDetails });
                        logAPI("MBHWeb.Saga.Rx.DefaultData.Get", start, null);
                    }
                    catch (pharmacyByStoreError) {
                        yield put({ type: types.GET_PHARMACY_BY_STORENUMBER_FAILURE, pharmacyByStoreError: pharmacyByStoreError });
                        logAPI("MBHWeb.Saga.Rx.DefaultData.Get.Failure", start, null, pharmacyByStoreError);
                    }
                    break;
                case types.INTERNAL_RX_TRANSFER_START:
                    try {
                        requestData = data ? data.payload : '';
                        const submittedResponse = yield call(pharmacy.submitRxTransfer, requestData, authToken, pharmacyProxyId);
                        if (submittedResponse) {
                            yield put({ type: types.INTERNAL_RX_TRANSFER_COMPLETED, serviceResponse: submittedResponse });
                            logAPI("MBHWeb.Saga.Rx.SubmitRxTransfer.Get", start, null);
                        }
                        if (data.callback) {
                            data.callback(submittedResponse, null);
                        }
                    }
                    catch (submitError) {
                        yield put({ type: types.INTERNAL_RX_TRANSFER_FAILURE, error: submitError });
                        logAPI("MBHWeb.Saga.Rx.SubmitRxTransfer.Get.Failure", start, null, submitError);
                        if (data.callback) {
                            data.callback(null, submitError);
                        }
                    }
                    break;
                case types.SET_FAVOURITE_PHARMACY_START:
                    try {
                        const response = yield call(pharmacy.setFavouritePharmacy, data.payload.storeNumber ? data.payload.storeNumber : '', pharmacyProxyId, authToken);
                        if (response === 'success') {
                            yield put({ type: types.SET_FAVOURITE_PHARMACY_SUCCESS, defaultPharmacyStoreNumber: data.payload.storeNumber });
                            logAPI("MBHWeb.Saga.Rx.SetFavorite.Get", start, null);
                        }
                        else {
                            yield put({ type: types.SET_FAVOURITE_PHARMACY_FAILURE, error: response });
                            logAPI("MBHWeb.Saga.Rx.SetFavorite.Get.Failure", start, null);
                        }
                    }
                    catch (pharmacyError) {
                        yield put({ type: types.SET_FAVOURITE_PHARMACY_FAILURE, error: pharmacyError });
                        logAPI("MBHWeb.Saga.Rx.SetFavorite.Get.Failure", start, null, pharmacyError);
                    }
                    break;
                case types.ARCHIVE_UNLINKED_RX_TRANSFER_START:
                    try {
                        const response = yield call(pharmacy.archiveUnlinkedRxTransfers, authToken);
                        if (response) {
                            yield put({ type: types.ARCHIVE_UNLINKED_RX_TRANSFER_SUCCESS, archivedUnlinkedRxResponse: response });
                            logAPI("MBHWeb.Saga.Rx.ArchiveUnlinkedRxTransfers.Get", start, null);
                        }
                        else {
                            yield put({ type: types.ARCHIVE_UNLINKED_RX_TRANSFER_FAILURE, error: response });
                            logAPI("MBHWeb.Saga.Rx.ArchiveUnlinkedRxTransfers.Get.Failure", start, null);
                        }
                    }
                    catch (pharmacyError) {
                        yield put({ type: types.ARCHIVE_UNLINKED_RX_TRANSFER_FAILURE, error: pharmacyError });
                        logAPI("MBHWeb.Saga.Rx.ArchiveUnlinkedRxTransfers.Get.Failure", start, null, pharmacyError);
                    }
                    break;
            }
        }
        catch (errObject) {
            console.error(errObject);
            if (errObject && errObject.status && errObject.status === 401) {
                yield put({ type: types.VERIFY_LOGIN });
            }
            else {
                try {
                    const sessionData = yield select((state) => state.session);
                    if (sessionData && sessionData.serverData && sessionData.serverData.developerDebug) {
                        //debugger;
                    }
                }
                catch (e) { }
                yield put({ type: types.AJAX_CALL_ERROR, pharmacyError: errObject });
            }
        }
    }
    else {
        console.log("pharmacySaga: rxDown");
    }
}

function* onReadyForPickup(pharmacyProxyId, token, storeNumber) {
    const start = new Date();
    try {
        const readyForPickup = yield call(pharmacy.getReadyForPickup, pharmacyProxyId, token);
        if (storeNumber) {
            let totalCost = 0;
            let rxList = readyForPickup.filter(item => item.storeNumber === storeNumber);
            const pharmacyInfo = yield call(pharmacy.getDefaultPharmacyData, storeNumber, pharmacyProxyId, token);
            if (typeof rxList.length === 'undefined') {
                yield call(getRxDetail, token, rxList);
                totalCost += Number.parseFloat(rxList.patientPay);
                rxList = { rxList };
            }
            else {
                for (let i = 0; i < rxList.length; i++) {
                    yield call(getRxDetail, token, rxList[i]);
                    totalCost += Number.parseFloat(rxList[i].patientPay);
                }
            }
            yield put({ type: types.RX_READY_FOR_PICKUP_SUCCESS, readyForPickupPharmacy: pharmacyInfo, readyForPickupList: rxList, readyForPickupTotalCost: totalCost });
            logAPI("MBHWeb.Saga.Rx.ReadyForPickup.Get", start, null);
        }
        else {
            yield put({ type: types.RX_READY_FOR_PICKUP_SUCCESS, readyForPickup: readyForPickup });
            logAPI("MBHWeb.Saga.Rx.ReadyForPickup.Get", start, null);
        }
    }
    catch (readyForPickupError) {
        yield put({ type: types.RX_READY_FOR_PICKUP_FAILURE, error: readyForPickupError });
        logAPI("MBHWeb.Saga.Rx.ReadyForPickup.Get.Failure", start, null, readyForPickupError);
    }
}

function* getRxDetail(token, rx) {
    const start = new Date();
    try {
        const rxDetail = yield call(pharmacy.getRxDetail, token, rx.rxNumber, rx.storeNumber);
        logAPI("MBHWeb.Saga.Rx.RxDetail.Get", start, null);
        rx.NDCImageURL = rxDetail.NDCImageURL;
        rx.RefillsUntilExpiry = rxDetail.RefillsUntilExpiry;
        rx.RefillsRemaining = rxDetail.RefillsRemaining;
        rx.RefillsAuthorized = rxDetail.RefillsAuthorized;
        rx.PrescriberName = rxDetail.PrescriberName;
        rx.PrescriberContactNumber = rxDetail.PrescriberContactNumber;
        rx.RxSig = rxDetail.RxSig;
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Rx.RxDetail.Get.Failure", start, null, error);
        console.error(error);
    }
}

function getErrorMessage(changeUserNameError) {
    return changeUserNameError.json().then(data => {

        return data.Message;
    });
}

function* handleUserSwitch(payload) {
    try {
        //debugger;
        const currentUser = payload.user;
        try {
            if (currentUser) {
                const sDomain = getDomain();
                yield put({ type: types.COOKIE_BSWPROXY_START });
                if (currentUser.relationshipId) {
                    Cookies.set('BSWPROXY', currentUser.relationshipId, { path: '/', domain: sDomain });
                }
                else {
                    Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
                }
                yield put({ type: types.COOKIE_BSWPROXY_SUCCESS });
            }
        }
        catch (e) {
            //debugger;
            console.error(e);
        }

        if (payload.callback) {
            payload.callback();
        }

        // Forward it on
        payload.type = types.SWITCH_USER_REDUCER;
        yield put(payload);
    }
    catch (err) {
        console.error(err);
    }
}

function parseRspMsg(rspMsg) {
    return rspMsg.json().then(data => {
        return data;
    });
}